import React, { useCallback, useContext, useState, useEffect } from 'react';
import _ from 'lodash';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { InputField, CheckboxField, DropdownSelectField, IconButton } from '@jutro/components';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { TranslatorContext } from '@jutro/locale';
import {ViewModelServiceContext} from 'gw-portals-viewmodel-react'
import { WizardPage, wizardProps } from 'gw-portals-wizard-react';
import { useDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { useValidation } from 'gw-portals-validation-react';
import { messages as paymentMessages } from 'gw-capability-policychange-common-react';
import wizardConfig from '../../config/ho-wizard-config.json5'
import metadata from './ItemDetailsPage.metadata.json5';
import './ItemDetailsPage.messages';
import styles from './ItemDetailsPage.module.scss';


function ItemDetailsPage(props) {
    const { steps } = wizardConfig;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const { wizardData, updateWizardData, authHeader, currentStepIndex, changeNextSteps, additionalWizardData, updateAdditionalWizardData} = props;
    const { submissionVM, selectedData } = wizardData;
    const { EndorsementService } = useDependencies('EndorsementService');
    const { 
        initialValidation,
        isComponentValid,
        registerComponentValidation 
    } = useValidation('ItemDetailsPage');

    const isDetailsComponentValid = useCallback(() => {
        if (
            (submissionVM.lobData.homeowners.allCoverables.value.filter((c) => {return !c.coveragePart || !c.coverageForm}).length > 0)
        ) {
            return false;
        }
        return true;
    }, [submissionVM]);

    useEffect(() => {
        submissionVM.lobData.homeowners.allCoverables.children.forEach((item) => {
            item.isHoValidationRequired.value = false;
            if(!item.isNew.value) {
                item.omiaDetail.isValidationRequired.value = false;
            }
        });        
        registerComponentValidation(isDetailsComponentValid);
    }, [registerComponentValidation, isDetailsComponentValid]);


    const onValueChange = useCallback((value, item, prop) => {
        if(prop.dataPath == 'isPrimary'){
            submissionVM.lobData.homeowners.allCoverables.children.forEach((c) => {
                c.isPrimary.value = false;
            })
        }
        const index = submissionVM.lobData.homeowners.allCoverables.value.indexOf(item.value);
        const path = `lobData.homeowners.allCoverables.children.${index}.${prop.dataPath}`;
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(newSubmissionVM, path, value);
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
        }, [submissionVM]
    );

    const deletePackage = (item, index, data) => {
        if(item.isNew.value){
            submissionVM.lobData.homeowners.allCoverables.value.splice(index, 1);        }
        else{
            item.isDelete.value = true;            
        }
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
        
    }

    const getDataTableCell = (item, index, props) => {
        const path = props.path;
        if(path == 'delete'){
            return (
            <IconButton
                className={styles.nexusIconButton}
                disabled={item.isPrimary.value}
                onClick={ () => {deletePackage(item, index, props)}}
                icon="mi-delete"
            ></IconButton>
            )
        } 
        const value = item[path].value;        
        if (path == 'dwellingCounter') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                    readOnly={true}
                    showRequired={true}
                />
            )
        }
        else if (path == 'isPrimary') {
            return (
                <CheckboxField
                    id={index + path}
                    onValueChange={onValueChange}
                    model={item}
                    dataPath={path}
                    value={value}
                />
            )
        }
        else if (path == 'coveragePart' || path == 'coverageForm') {
            const availableValues = _.get(item, `${path}.aspects.availableValues`)
                .map((i) => {
                    const name = translator({ id: i.name });
                    return { code: i.code, name: name }
                });
                const readOnly = path == 'coveragePart' ? !item.isNew.value : false;
                const disabled = path == 'coverageForm' ? !item.coveragePart.value : false;
            return (
                <DropdownSelectField
                    className={styles.coverageForm}
                    id={index + path}
                    onValueChange={onValueChange}
                    dataType="string"
                    model={item}
                    dataPath={path}
                    value={value}
                    availableValues={availableValues}
                    readOnly={readOnly}
                    disabled={disabled}
                    searchable={true}
                />
            )
        }              

    };

    const addPackageItem = () => {
        const packageItem = {
            dwellingCounter: "",
            isPrimary:false,
            coveragePart:"",
            coverageForm:"",
            isNew: true
        }
        submissionVM.lobData.homeowners.allCoverables.value.push(packageItem);
        const newSubmissionVM = viewModelService.clone(submissionVM);
        _.set(wizardData, 'submissionVM', newSubmissionVM);
        updateWizardData(wizardData);
    }

    const onNext = useCallback(async () => { 
        const packageInfo = [];
        _.each(submissionVM.lobData.homeowners.allCoverables.value, (item, index)=>{
            if(!item.isDelete){
                packageInfo.push(item.isNew)
            }
        });
        submissionVM.value = await EndorsementService.saveEndorsement(
            [submissionVM.value],
            authHeader
        );
        let _item = {}
         _.each(submissionVM.lobData.homeowners.allCoverables.value, (item, index)=>{
            _item[item.publicID] = !!(additionalWizardData && additionalWizardData.packageInfoDetails && additionalWizardData.packageInfoDetails[item.publicID]) || packageInfo[index];
            return _item;
        });
        let _additionalWizardData = _.clone(additionalWizardData);
        _additionalWizardData['packageInfoDetails'] = _item;
        updateAdditionalWizardData(_additionalWizardData);
        return wizardData;
    }, [
        EndorsementService, 
        authHeader,
        currentStepIndex,
        changeNextSteps,
        selectedData,
        steps, 
        submissionVM, 
        wizardData
    ]);    

    const overrideProps =  {
        '@field': {
            labelPosition: 'left'
        },
        addPackage:{
            onClick: addPackageItem
        },
        packageDataTable: {
            data: submissionVM.lobData.homeowners.allCoverables.children.filter((c)=>{return !c.isDelete.value})
        },
        deletePackage:{
            disabled: submissionVM.lobData.homeowners.allCoverables.children.length === 1
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            getDataTableCell: getDataTableCell,
            deletePackage: deletePackage
        }
    };
   
    return (
        <WizardPage
            onNext={onNext}
            disableNext={!isComponentValid}
            skipWhen={initialValidation}
            cancelLabel={translator(appConfig.persona === 'policyholder' ? paymentMessages.cancelAllChanges : paymentMessages.cancel)}
            showPrevious
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={styles}
            />
        </WizardPage>
    );
}

ItemDetailsPage.propTypes = wizardProps;
export default withAuthenticationContext(ItemDetailsPage);
